exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-history-log-display[data-v-33ad5a1d]{overflow-wrap:break-word}", ""]);

// exports
